import { trackEvent } from "@/lib/audit";

const KEY = "ss2026_daily_checkin_v1";

interface CheckInState {
  last_claimed_date: string | null;
  total_claims: number;
}

function today() { return new Date().toISOString().slice(0, 10); }

function read(): CheckInState {
  if (typeof window === "undefined") return { last_claimed_date: null, total_claims: 0 };
  try { return JSON.parse(localStorage.getItem(KEY) ?? "null") as CheckInState ?? { last_claimed_date: null, total_claims: 0 }; }
  catch { return { last_claimed_date: null, total_claims: 0 }; }
}
function write(s: CheckInState) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function canClaimToday(): boolean {
  return read().last_claimed_date !== today();
}

export function getCheckInState(): CheckInState { return read(); }

/** Reward grows with consecutive day index (day 1 = 5, day 7 = 50). */
export function rewardForDay(dayIndex: number): number {
  const table = [5, 8, 12, 18, 25, 35, 50];
  return table[Math.min(Math.max(dayIndex, 1), 7) - 1];
}

export function claimDailyCheckIn(dayIndex: number): number {
  const s = read();
  if (s.last_claimed_date === today()) return 0;
  const reward = rewardForDay(dayIndex);
  const next: CheckInState = {
    last_claimed_date: today(),
    total_claims: s.total_claims + 1,
  };
  write(next);
  void trackEvent("daily_checkin_claimed", { day_index: dayIndex, reward, total_claims: next.total_claims });
  return reward;
}